<script>

    import { toast } from 'bulma-toast'
    import { providerStore, providersStore, modalStore } from '../stores'

    import ProvidersService from '../$services/providers.service.js'
    import DateMethod from '../$methods/date.method.js'

    import Spinner from '../$components/spinner.svelte'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'
    import Button from '../$components/button.svelte'
    import Data from '../$components/data.svelte'

    export let showTitle = true
    let loading = false

    async function deleteProvider() {

        loading = true
        const resp = await ProvidersService.deleteProvider($providerStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        providersStore.remove($providerStore._id)
        toast({message: 'Proveedor borrado', type: 'is-success'})

        modalStore.close()
    }

</script>

{#if showTitle}
    <div class="subtitle is-5">Proveedor</div>
{/if}

<Spinner {loading} />

{#if !loading}
    <DetailsCard
        title={$providerStore.name}
        meta={DateMethod.dateTimeLarge($providerStore.created)}
        statusValue={$providerStore.status}
    >
        <DetailsFields>
            <DetailsField label="Cobertura con costo" value={`$${$providerStore.coverageCost}`} mono />
            {#if $providerStore.name === 'Redpack'}
                <DetailsField label="Cobertura especial" value={`$${$providerStore.coverageSpecial}`} mono />
            {/if}
        </DetailsFields>

        <div slot="footer">
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <Button on:click={() => modalStore.open('provider', 'update_modal', $providerStore)} icon="edit" text="Actualizar" {loading} />
                <ButtonDelete on:confirm={deleteProvider} {loading} />
            </div>
        </div>
    </DetailsCard>
{/if}

{#if $providerStore.name != 'Partner'}

    <div class="subtitle is-5">Servicios</div>

    {#each $providerStore.services as service}
        <div class="columns">
            <div class="column is-3">
                <Data name="Servicio" value={ service.name } />
            </div>
            <div class="column is-3">
                <Data name="Precio" value={ service.setPrice } />
            </div>
            {#if service.setPrice === 'percent'}
                <div class="column is-3">
                    <Data name="Porcentaje" value={ service.percent } />
                    {#if service.volumetricMax}
                        <div>{ service.volumetricMin }kg a { service.volumetricMax }kg</div>
                    {/if}
                </div>
                <div class="column is-3">
                    <Data name="IVA" value={ service.iva } />
                </div>
            {/if}
            {#if service.setPrice === 'flat'}
                <div class="column is-2">
                    <Data name="Peso referencia" value={ service.weightControl } />
                </div>
                <div class="column is-2">
                    <Data name="Precio base" value={ service.shipmentPrice } />
                </div>
                <div class="column is-2">
                    <Data name="Costo por kilo" value={ service.weightCost } />
                </div>
            {/if}
        </div>
    {/each}
{/if}
